class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6H26.1719L22.5859 2.4141L24 1L30 7L24 13L22.5859 11.5859L26.1719 8H6V15H4V8C4.00064 7.46976 4.21155 6.96142 4.58649 6.58649C4.96142 6.21155 5.46976 6.00064 6 6Z" fill="#16191D"></path><path d="M9.4141 20.4141L5.8281 24H26V17H28V24C27.9994 24.5302 27.7884 25.0386 27.4135 25.4135C27.0386 25.7884 26.5302 25.9994 26 26H5.8281L9.414 29.5859L8 31L2 25L8 19L9.4141 20.4141Z" fill="#16191D"></path></svg>';
  }
}
const e = "pwc-icon-repeat";
customElements.get(e) || customElements.define(e, t);
